module.exports = __webpack_public_path__ + "static/vr-4-1-6bd9f9e7eede92f69d25e0e8f1375944.jpeg";